<div class="container">
  <h3 class="up-next-title fw-bold text-white text-uppercase">{{ 'fantasy.up.next.text' | translate }}</h3>
  <p class="font-size-14 mb-0 text-white">{{ 'fantasy.up.next.description' | translate }}</p>

  <div class="up-next-games d-flex flex-column">
    <ng-container *ngIf="upNextGames$ | async as games">
      @for (game of games; track game.GameId) {
        <div class="up-next-game-card d-flex flex-column align-items-center justify-content-center bg-primary">
          <div class="teams-details">
            <div class="home-team">
              <p class="team-name font-size-14 text-white fw-bold text-capitalize mb-0 text-end">
                {{ game.HomeTeamName }}
              </p>
              <img [src]="game.HomeTeamLogo" alt="home team image" />
            </div>

            <span class="vs-text font-size-14 fw-bold text-uppercase text-white">
              {{ 'fantasy.game.vs' | translate }}
            </span>

            <div class="away-team">
              <img [src]="game.AwayTeamLogo" alt="away team image" />
              <p class="team-name font-size-14 text-white fw-bold text-capitalize mb-0 text-start">
                {{ game.AwayTeamName }}
              </p>
            </div>
          </div>

          <p class="font-size-12 text-white mb-0">{{ game.Date }} - {{ game.Time }}</p>
        </div>
      } @empty {
        <div class="no-items w-100 text-center bg-glass">
          <div class="svg svg-info vs-svg ms-auto me-autoo" fgbAnimateSvg>
            <img class="placeholder-image" [src]="'placeholders/pick-a-player.svg' | contentAssetImage" />
          </div>
          <p class="text-center font-size-14 mb-0 text-white">
            {{ 'pick.player.upcoming.placeholder' | translate }}
          </p>
        </div>
      }
    </ng-container>
  </div>
</div>
